import React from 'react';

const Loader = (props) => {

	return (
		<div className="loader">
			<img src={'/images/loader-anim' + (props.whiteBg ? '-inline' : '') + '.svg'} alt="loading..." className="not-ie" />
			<img src={'/images/loader-anim' + (props.whiteBg ? '-inline' : '') + '-ie.gif'} alt="loading..." className="ie" />
		</div>
	);

};

export default Loader;


// WEBPACK FOOTER //
// ./resources/assets/js/elements/Loader.js